
export default {
	data () {
		return {
		}
	},

	methods: {
		
	},

    mounted () {
    }
}